import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AuthLayout from "../../../components/layout/AuthLayout";
import { moduleName } from "../../../constants";
import { getRoutes } from "../../../routes/Routes";
import { loginUser } from "../../../redux/actions/auth";


const Login = () => {
  const { module } = useSelector((state) => state.loadingSlice);

  const onFinish = async (values) => {
    await loginUser(values);
  };

  return (
    <AuthLayout
      title="Welcome Back!"
      subtitle="Log in to your account to continue"
      actionText="Don’t have an account?"
      actionLabel="Sign Up"
      actionLink={getRoutes().register.route()}
    >
      <Form layout="vertical" size="large" onFinish={onFinish} className="tight-form">
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: "Please enter your email" },
            { type: "email", message: "Enter a valid email" },
          ]}
        >
          <Input prefix={<UserOutlined />} placeholder="Enter your email" />
        </Form.Item>

        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true, message: "Please enter your password" }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Enter your password"
          />
        </Form.Item>

        <div className="auth-extra">
          <Link to={getRoutes().forgot.route()}>
            Forgot password?
          </Link>
        </div>

        <Button
          type="primary"
          htmlType="submit"
          block
          loading={module === moduleName.LOGIN}
          size="large"
          className="mt-2"
        >
          Log In
        </Button>
      </Form>
    </AuthLayout>
  );
};

export default Login;